import React, { useEffect, useState } from 'react'
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './visa.css'
import dayjs from 'dayjs'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import PropTypes from 'prop-types';
import { Tab, Tabs, TextField, Box, Autocomplete, FormControl, Typography, Accordion, AccordionActions, AccordionSummary, AccordionDetails, Button } from '@mui/material';
import Carousel from 'react-multi-carousel'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Link, useNavigate } from 'react-router-dom'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { visaBooking, visaCountry } from '../../api/visa'
import { ToastContainer, toast } from 'react-toastify'
import HotelDetail from '../hotels/HotelDetail'
import { fileUpload } from '../../utils/request'
import { packageCity, packageGet } from '../../api/package'
// -------------------------------------------------


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Vehicles = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
}
const Customer = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 6,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 6,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
}

const destination = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
}

const Visa = () => {
  const navigate = useNavigate()
  const colors = ['#f4f4f4', '#e2f2ff', '#ffefe2',];
  const [value, setValue] = React.useState(0);
  const notify = (message) => toast(message)
  const handleChange = (event, newValue, oddValue) => {
    if (cabDetails.visaCountry === '') {
      notify('Visa Country is required')
    } else if (cabDetails.visaType === '') {
      notify('Visa Type is required')
    } else if (cabDetails.visaValidity === '') {
      notify('VisaValidity is required')
    } else if (cabDetails.nationality === '') {
      notify('nationality is required')
    } else {
      setValue(newValue)
      if (oddValue === 'hit' && newValue === 0) {
        setCabDetails({
          visaCountry: "",
          visaType: "",
          visaValidity: "",
          nationality: '',

          dateOfIssue: "",
          dateOfExpiry: '',
          passportNumber: '',
          dateOfBirth: '',
          middleName: '',
          lastName: '',
          gender: '',
          countryOfBirth: '',
          religion: '',
          // AgentEmail: '',
          // agentMobile: '',
          motherName: '',
          fatherName: '',
          placeOfBirth: '',
          maritalStatus: '',
          spouseName: '',
          profession: '',
          firstName: '',
          // colorPhoto: '', passportFirstPage: '', passportLastPage: ''
        })
      }
      else if (newValue === 0 && oddValue !== 'hit') {
        setCabDetails({
          ...cabDetails,

          dateOfIssue: "",
          dateOfExpiry: '',
          passportNumber: '',
          dateOfBirth: '',
          middleName: '',
          lastName: '',
          gender: '',
          countryOfBirth: '',
          religion: '',
          // AgentEmail: '',
          // agentMobile: '',
          motherName: '',
          fatherName: '',
          placeOfBirth: '',
          maritalStatus: '',
          spouseName: '',
          profession: '',
          firstName: '',
          // colorPhoto: '', passportFirstPage: '', passportLastPage: ''
        })
      }
    }

  };
  const [cabDetails, setCabDetails] = useState({

    visaCountry: "",
    visaType: "",
    visaValidity: "",
    nationality: '',
    dateOfIssue: "",
    dateOfExpiry: '',
    passportNumber: '',
    dateOfBirth: '',
    middleName: '',
    lastName: '',
    gender: '',
    countryOfBirth: '',
    religion: '',
    // AgentEmail: '',
    // agentMobile: '',
    motherName: '',
    fatherName: '',
    placeOfBirth: '',
    maritalStatus: '',
    spouseName: '',
    profession: '',
    firstName: '',
    // colorPhoto: '', passportFirstPage: '', passportLastPage: ''

  })
  const lifeStatus = ["married", "single", "widowed", "divorced", "separated"]
  const tomorrow = dayjs()

  function checkEmptyKeys(obj, optionFields) {
    for (const key in obj) {
      if ((obj[key] === "" || obj[key] === 0) && !optionFields.includes(key)) {
        return true;
      }
    }
    return false;
  }
  const token = localStorage.getItem('token')

  const submit = async () => {
    if (token) {
      if (cabDetails?.firstName === '') {
        notify('Frist Name is required')
      } else if (cabDetails?.lastName === '') { notify('Last Name is required') }
      else if (cabDetails?.fatherName === '') { notify('Father Name is required') }
      else if (cabDetails?.motherName === '') { notify('Mother Name is required') }
      else if (cabDetails?.spouseName === '' && (cabDetails?.maritalStatus === 'married' || cabDetails?.maritalStatus === 'widowed')) { notify('Spouse is required') }
      else if (cabDetails?.gender === '') { notify('Gender is required') }
      else if (cabDetails?.maritalStatus === '') { notify('Marital Status is required') }
      else if (cabDetails?.nationality === '') { notify('Nationality is required') }
      else if (cabDetails?.passportNumber === '') { notify('Passport Number is required') }
      else if (cabDetails?.placeOfBirth === '') { notify('Place Of Birth is required') }
      else if (cabDetails?.profession === '') { notify('Profession is required') }
      else if (cabDetails?.religion === '') { notify('Religion is required') }
      else if (cabDetails?.visaCountry === '') { notify('Visa Country is required') }
      else if (cabDetails?.visaType === '') { notify('Visa Type is required') }
      else if (cabDetails?.visaValidity === '') { notify('Visa Validity is required') }
      else if (cabDetails?.countryOfBirth === '') { notify('Country of birth is required') }
      else if (cabDetails?.dateOfBirth === '') { notify('Date of Birth is required') }
      else if (cabDetails?.dateOfExpiry === '') { notify('Date Of Expiry is required') }
      else if (cabDetails?.dateOfIssue === '') { notify('Date Of Issue is required') }

      else {
        try {
          const resp = await visaBooking(cabDetails)
          if (resp.code === 201) {
            notify(resp.message)
            setCabDetails({

              visaCountry: "",
              visaType: "",
              visaValidity: "",
              nationality: '',
              dateOfIssue: "",
              dateOfExpiry: '',
              passportNumber: '',
              dateOfBirth: '',
              middleName: '',
              lastName: '',
              gender: '',
              countryOfBirth: '',
              religion: '',
              // AgentEmail: '',
              // agentMobile: '',
              motherName: '',
              fatherName: '',
              placeOfBirth: '',
              maritalStatus: '',
              spouseName: '',
              profession: '',
              firstName: '',
              // colorPhoto: '', passportFirstPage: '', passportLastPage: ''

            })
            handleChange(null, 0, 'hit')
          } else {
            notify(resp.message)
            setCabDetails({

              visaCountry: "",
              visaType: "",
              visaValidity: "",
              nationality: '',
              dateOfIssue: "",
              dateOfExpiry: '',
              passportNumber: '',
              dateOfBirth: '',
              middleName: '',
              lastName: '',
              gender: '',
              countryOfBirth: '',
              religion: '',
              // AgentEmail: '',
              // agentMobile: '',
              motherName: '',
              fatherName: '',
              placeOfBirth: '',
              maritalStatus: '',
              spouseName: '',
              profession: '',
              firstName: '',
              // colorPhoto: '', passportFirstPage: '', passportLastPage: ''

            })
          }
        } catch (error) {
          notify(error.message)
          setCabDetails({

            visaCountry: "",
            visaType: "",
            visaValidity: "",
            nationality: '',
            dateOfIssue: "",
            dateOfExpiry: '',
            passportNumber: '',
            dateOfBirth: '',
            middleName: '',
            lastName: '',
            gender: '',
            countryOfBirth: '',
            religion: '',
            // AgentEmail: '',
            // agentMobile: '',
            motherName: '',
            fatherName: '',
            placeOfBirth: '',
            maritalStatus: '',
            spouseName: '',
            profession: '',
            firstName: '',
            // colorPhoto: '', passportFirstPage: '', passportLastPage: ''

          })
        }


      }
    } else {
      notify('Please Login for booking')
    }

  }

  const [countries, setCountries] = useState([])

  const getCountries = async () => {
    const resp = await visaCountry()
    setCountries(resp.data)
  }

  useEffect(() => {
    getCountries()
  }, [])

  const top100Films = countries?.map((items) => {
    return { label: items?.name, value: items?.name }
  })

  const [tourDetail, setTourDetail] = useState({
    city: '',
    type: ''
  })

  const [tourData, setTourData] = useState([])
  const [tourInternationalData, setTourInternationalData] = useState([])
  const getPackages = async () => {
    if (tourDetail.type === '') {
      alert('Please fill type')
    } else if (tourDetail.city === '') {
      alert('Please fill City')
    } else {
      const resp = await packageGet(tourDetail)
      const filterInterNational = resp.data?.filter((item) => {
        return item?.packageMode === 'International'
      })
      const national = resp.data?.filter((item) => {
        return item?.packageMode === 'National'
      })
      setTourInternationalData(filterInterNational)
      setTourData(national)
    }
  }


  const getPackage = async () => {
    const resp = await packageGet()
    const filterInterNational = resp.data?.filter((item) => {
      return item?.packageMode === 'International'
    })
    const national = resp.data?.filter((item) => {
      return item?.packageMode === 'National'
    })
    setTourInternationalData(filterInterNational)
    setTourData(national)
  }

  useEffect(() => {
    getPackage()
  }, [])


  return (
    <>
      <Header />
      <section className=''>
        <div className='container'>
          <div className="mainBannerSectionVisa">
            <Box
              className='w-1'
              sx={{
                width: '60%',
                backgroundColor: '#fff',
                borderRadius: '10px',
              }}>
              <h1>Book Your Online Visa</h1>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '0px 25px 0px 25px',
                }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label="Visa Details" {...a11yProps(0)} />
                  <Tab label="Personal Details" {...a11yProps(1)} />
                </Tabs>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <div className='row'>
                  <div className='col-md-4 col-lg-4 py-2'>
                    <Autocomplete
                      size='small'
                      sx={{ mt: 1 }}
                      disablePortal
                      id="combo-box-demo"
                      options={top100Films}
                      getOptionLabel={(option) => {
                        if (option.label) {
                          return option.label
                        } else if (typeof option === 'string') {
                          return option
                        } else {
                          return ""
                        }
                      }
                      }
                      isOptionEqualToValue={(option, value) => {
                        if (option.value && value.value) { return option.value === value.value } else {
                          return false
                        }
                      }}
                      value={cabDetails.visaCountry}
                      onChange={(e, newValue) => {
                        setCabDetails({
                          ...cabDetails,
                          visaCountry: newValue.value
                        })
                      }}
                      renderInput={(params) => <TextField {...params} label="Visa Country" placeholder="Visa Country" />}
                    />
                  </div>
                  <div className='col-md-4 col-lg-4 py-2'>
                    <Autocomplete
                      size='small'
                      sx={{ mt: 1 }}
                      disablePortal
                      id="combo-box-demo"
                      options={visaType}
                      getOptionLabel={(option) => {
                        if (option.label) {
                          return option.label
                        } else if (typeof option === 'string') {
                          return option
                        } else {
                          return ""
                        }
                      }
                      }
                      isOptionEqualToValue={(option, value) => {
                        if (option.value && value.value) { return option.value === value.value } else {
                          return false
                        }
                      }}
                      value={cabDetails.visaType}
                      onChange={(e, newValue) => {
                        setCabDetails({
                          ...cabDetails,
                          visaType: newValue.value
                        })
                      }}
                      renderInput={(params) => <TextField {...params} label="Visa Type" placeholder="Visa Type" />}
                    />
                  </div>
                  <div className='col-md-4 col-lg-4 py-2'>
                    <Autocomplete
                      size='small'
                      sx={{ mt: 1 }}
                      disablePortal
                      id="combo-box-demo"
                      getOptionLabel={(option) => {
                        if (option.label) {
                          return option.label
                        } else if (typeof option === 'string') {
                          return option
                        } else {
                          return ""
                        }
                      }
                      }
                      isOptionEqualToValue={(option, value) => {
                        if (option.value && value.value) { return option.value === value.value } else {
                          return false
                        }
                      }}
                      options={visaValidity}
                      value={cabDetails.visaValidity}
                      onChange={(e, newValue) => {
                        setCabDetails({
                          ...cabDetails,
                          visaValidity: newValue.value
                        })
                      }}
                      renderInput={(params) => <TextField {...params} label="Visa Validity" placeholder="Visa Validity" />}
                    />
                  </div>
                  <div className='col-md-4 col-lg-4 py-2'>
                    <FormControl sx={{ mt: 1 }} className='w-100'>
                      <InputLabel size='small' id="demo-simple-select-label">Nationality</InputLabel>
                      <Select
                        size='small'
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Nationality"
                        value={cabDetails.nationality}
                        onChange={(e) => {
                          setCabDetails({
                            ...cabDetails,
                            nationality: e.target.value
                          })
                        }}
                      >
                        <MenuItem value={'Indian'}>Indian</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-12 text-center mt-4">
                    <button
                      onClick={() => {
                        if (cabDetails.visaCountry === '') {
                          notify('Visa Country is required')
                        } else if (cabDetails.visaType === '') {
                          notify('Visa Type is required')
                        } else if (cabDetails.visaValidity === '') {
                          notify('VisaValidity is required')
                        } else if (cabDetails.nationality === '') {
                          notify('nationality is required')
                        }
                        else {
                          handleChange(null, 1, '')
                        }

                      }}
                      className="btn btn-dark w-100" href="#">
                      Next
                    </button>
                  </div>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <div className='row'>
                  <div className='col-md-4 col-lg-4 py-2 dateCol'>
                    <TextField
                      value={cabDetails.passportNumber}
                      onChange={(e) => {
                        setCabDetails({
                          ...cabDetails,
                          passportNumber: e.target.value
                        })
                      }}
                      size='small' placeholder='Passport No.' label='Passport No.' />
                  </div>
                  <div className='col-md-4 col-lg-4 py-2 dateCol'>
                    <TextField
                      value={cabDetails.firstName}
                      onChange={(e) => {
                        setCabDetails({
                          ...cabDetails,
                          firstName: e.target.value
                        })
                      }}
                      size='small' placeholder='First Name' label='First Name' />
                  </div>
                  <div className='col-md-4 col-lg-4 py-2 dateCol'>
                    <TextField
                      value={cabDetails.middleName}
                      onChange={(e) => {
                        setCabDetails({
                          ...cabDetails,
                          middleName: e.target.value
                        })
                      }}
                      size='small' placeholder='Middle Name' label='Middle Name' />
                  </div>
                  <div className='col-md-4 col-lg-4 pb-2 pt-3 dateCol'>
                    <TextField
                      value={cabDetails.lastName}
                      onChange={(e) => {
                        setCabDetails({
                          ...cabDetails,
                          lastName: e.target.value
                        })
                      }}
                      size='small' placeholder='Last Name' label='Last Name' />
                  </div>
                  <div className='col-md-4 col-lg-4 py-2 dateCol'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['DatePicker']}>
                        <DatePicker
                          label="Date of Issue"
                          slotProps={{ textField: { size: 'small' } }}
                          value={cabDetails.dateOfIssue}
                          onChange={(newValue) => {
                            const date = new Date(newValue['$d']);
                            setCabDetails({
                              ...cabDetails,
                              dateOfIssue: date
                            })
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                  <div className='col-md-4 col-lg-4 py-2 dateCol'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['TimePicker']}>
                        <DatePicker
                          label="Date of Expiry"
                          minDate={dayjs(cabDetails?.dateOfIssue)}
                          slotProps={{ textField: { size: 'small' } }}
                          value={cabDetails.dateOfExpiry}
                          onChange={(newValue) => {
                            const date = new Date(newValue['$d']);
                            setCabDetails({
                              ...cabDetails,
                              dateOfExpiry: date
                            })
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                  <div className='col-md-4 col-lg-4 py-2 dateCol'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['DatePicker']}>
                        <DatePicker
                          label="Date of Birth"
                          maxDate={dayjs()}
                          slotProps={{ textField: { size: 'small' } }}
                          value={cabDetails.dateOfBirth}
                          onChange={(newValue) => {
                            const date = new Date(newValue['$d']);
                            setCabDetails({
                              ...cabDetails,
                              dateOfBirth: date
                            })
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                  <div className='col-md-4 col-lg-4 py-2'>
                    <FormControl sx={{ mt: 1 }} className='w-100'>
                      <InputLabel size='small' id="demo-simple-select-label">Gender</InputLabel>
                      <Select
                        size='small'
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Gender"
                        value={cabDetails.gender}
                        onChange={(e) => {
                          setCabDetails({
                            ...cabDetails,
                            gender: e.target.value
                          })
                        }}
                      >
                        <MenuItem value={'male'}>Male</MenuItem>
                        <MenuItem value={'female'}>Female</MenuItem>
                        <MenuItem value={'other'}>Other</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className='col-md-4 col-lg-4 py-2 dateCol'>
                    <TextField
                      value={cabDetails.countryOfBirth}
                      onChange={(e) => {
                        setCabDetails({
                          ...cabDetails,
                          countryOfBirth: e.target.value
                        })
                      }}
                      size='small' placeholder='Country of Birth' label='Country of Birth' />
                  </div>
                  <div className='col-md-4 col-lg-4 py-2 dateCol'>
                    <TextField
                      value={cabDetails.religion}
                      onChange={(e) => {
                        setCabDetails({
                          ...cabDetails,
                          religion: e.target.value
                        })
                      }}
                      size='small' placeholder='Religion' label='Religion' />
                  </div>
                  {/* <div className='col-md-4 col-lg-4 py-2 dateCol'>
                    <TextField
                      value={cabDetails.AgentEmail}
                      onChange={(e) => {
                        setCabDetails({
                          ...cabDetails,
                          AgentEmail: e.target.value
                        })
                      }}
                      size='small' placeholder='E-mail(Agent)' label='E-mail(Agent)' />
                  </div>
                  <div className='col-md-4 col-lg-4 py-2 dateCol'>
                    <TextField
                      value={cabDetails.agentMobile}
                      onChange={(e) => {
                        setCabDetails({
                          ...cabDetails,
                          agentMobile: e.target.value
                        })
                      }}
                      size='small' placeholder='Contact No(Agent)' label='Contact No(Agent)' />
                  </div> */}
                  <div className='col-md-4 col-lg-4 py-2 dateCol'>
                    <TextField
                      value={cabDetails.motherName}
                      onChange={(e) => {
                        setCabDetails({
                          ...cabDetails,
                          motherName: e.target.value
                        })
                      }}
                      size='small' placeholder='Mother Name' label='Mother Name' />
                  </div>
                  <div className='col-md-4 col-lg-4 py-2 dateCol'>
                    <TextField
                      value={cabDetails.fatherName}
                      onChange={(e) => {
                        setCabDetails({
                          ...cabDetails,
                          fatherName: e.target.value
                        })
                      }}
                      size='small' placeholder='Father Name' label='Father Name' />
                  </div>
                  <div className='col-md-4 col-lg-4 py-2 dateCol'>
                    <TextField
                      value={cabDetails.placeOfBirth}
                      onChange={(e) => {
                        setCabDetails({
                          ...cabDetails,
                          placeOfBirth: e.target.value
                        })
                      }}
                      size='small' placeholder='Place of Birth' label='Place of Birth' />
                  </div>
                  <div className='col-md-4 col-lg-4 py-2'>
                    <FormControl sx={{ mt: 1 }} className='w-100'>
                      <InputLabel size='small' id="demo-simple-select-label">Marital Status</InputLabel>
                      <Select
                        size='small'
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Marital Status"
                        value={cabDetails.maritalStatus}
                        onChange={(e) => {
                          setCabDetails({
                            ...cabDetails,
                            maritalStatus: e.target.value
                          })
                        }}
                      >
                        {lifeStatus.map((items, index) => (
                          <MenuItem key={index} value={items}>{items}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className='col-md-4 col-lg-4 pb-2 pt-3 dateCol'>
                    <TextField
                      value={cabDetails.spouseName}
                      onChange={(e) => {
                        setCabDetails({
                          ...cabDetails,
                          spouseName: e.target.value
                        })
                      }}
                      size='small' placeholder='Spouse Name' label='Spouse Name' />
                  </div>
                  <div className='col-md-4 col-lg-4 pb-2 pt-3 dateCol'>
                    <TextField
                      value={cabDetails.profession}
                      onChange={(e) => {
                        setCabDetails({
                          ...cabDetails,
                          profession: e.target.value
                        })
                      }}
                      size='small' placeholder='Profession' label='Profession' />
                  </div>
                  {/* <div className='col-md-4 col-lg-4 py-2'>
                    <label>Color Photo</label>
                    <div className="upload__image">
                      <>
                        <div className="dFlex"
                          style={{ marginBottom: '10px' }}
                        >
                          <div
                            className="image__preview"
                          >
                            {cabDetails?.colorPhoto !== '' ? (
                              <img style={{ height: '50px', width: '50px' }} src={cabDetails?.colorPhoto} />
                            ) : (
                              <img style={{ height: '50px', width: '50px' }} src='../../images/no-image.jpg' />
                            )}
                          </div>
                          <input onChange={async (e) => {
                            const data = await fileUpload(e.target.files[0], '/file')
                            setCabDetails({
                              ...cabDetails,
                              colorPhoto: data.fileUrl
                            })
                          }} type='file'
                            accept="image/*"
                          />
                        </div>
                      </>
                    </div>
                  </div>
                  <div className='col-md-4 col-lg-4 py-2'>
                    <label>Passport First Page</label>
                    <div className="upload__image">
                      <>
                        <div className="dFlex"
                          style={{ marginBottom: '10px' }}
                        >
                          <div
                            className="image__preview"
                          >
                            {cabDetails?.passportFirstPage !== '' ? (
                              <img style={{ height: '50px', width: '50px' }} src={cabDetails?.passportFirstPage} />
                            ) : (
                              <img style={{ height: '50px', width: '50px' }} src='../../images/no-image.jpg' />
                            )}
                          </div>
                          <input onChange={async (e) => {
                            const data = await fileUpload(e.target.files[0], '/file')
                            setCabDetails({
                              ...cabDetails,
                              passportFirstPage: data.fileUrl
                            })
                          }} type='file'
                            accept="image/*"
                          />
                        </div>
                      </>
                    </div>
                  </div>
                  <div className='col-md-4 col-lg-4 py-2'>
                    <label>Passport Last Page</label>
                    <div className="upload__image">
                      <>
                        <div className="dFlex"
                          style={{ marginBottom: '10px' }}
                        >
                          <div
                            className="image__preview"
                          >
                            {cabDetails?.passportLastPage !== '' ? (
                              <img style={{ height: '50px', width: '50px' }} src={cabDetails?.passportLastPage} />
                            ) : (
                              <img style={{ height: '50px', width: '50px' }} src='../../images/no-image.jpg' />
                            )}
                          </div>
                          <input onChange={async (e) => {
                            const data = await fileUpload(e.target.files[0], '/file')
                            setCabDetails({
                              ...cabDetails,
                              passportLastPage: data.fileUrl
                            })
                          }} type='file'
                            accept="image/*"
                          />
                        </div>
                      </>
                    </div>
                  </div> */}

                  <div className="col-12 text-center mt-4">
                    <button
                      onClick={() => {
                        submit()
                      }}
                      className="btn btn-dark w-100" href="#">
                      Book Now
                    </button>
                  </div>
                </div>
              </CustomTabPanel>
            </Box>
          </div>
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-10">
              <h4 className="mb-0 title">International Packages</h4>
            </div>
            <div className="col-2 text-end">
              <Link to="/tours/International" className="btn btn-lg btn-dark mb-0">View All</Link>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              {tourInternationalData?.map((items) => (
                <div onClick={() => {
                  navigate(`/tourDetail/${items?._id}`)
                }}

                  key={items?._id} className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src={items?.images?.[0]} alt='' />
                    {/* <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6> */}
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">{items?.city} </a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">₹ {items?.price}</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              ))}
              {/* <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div> */}
            </Carousel>
          </div >
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-10">
              <h4 className="mb-0 title">Domestic Packages</h4>
            </div>
            <div className="col-2 text-end">
              <Link to="/tours/Domestic" className="btn btn-lg btn-dark mb-0">View All</Link>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              {tourData?.map((items) => (
                <div onClick={() => {
                  navigate(`/tourDetail/${items?._id}`)
                }}

                  key={items?._id} className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src={items?.images?.[0]} alt='' />
                    {/* <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6> */}
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">{items?.city} , India</a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">₹ {items?.price}</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              ))}
              {/* <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div> */}
            </Carousel>
          </div >
        </div >
      </section >

      <section className='specialOffers'>
        <div className='container'>
          <div className="bg-light rounded-3 position-relative p-4 p-sm-5">
            <div className="row align-items-center position-relative dicoverSec">
              <div className="col-lg-8">
                <div className="d-flex">
                  <h3>It's time to discover</h3>
                  <img src="images/04-DrYI6v5l.svg" className="h-40px ms-3" alt="" />
                </div>
                <p className="mb-3 mb-lg-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.  </p>
              </div>
              <div className="col-lg-4 text-lg-end"><Link to="/tour" className="btn btn-lg btn-dark mb-0">Book Now</Link></div>
            </div>
          </div>
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Top Categories</h4>
            </div>
          </div>
          <div className="row g-4 g-xl-5 topCate">
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Adventure`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/19-BYcWTs_B.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Adventure</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/SoundScape`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/13-CeWMv36_.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Sound Scape</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Desert`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/18-C_X3yjnw.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Desert</a></h5>
                    {/* <span>1587 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Pilgrims`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/19-BYcWTs_B.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Pilgrims</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/History`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/17-E7K6iGPB.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">History</a></h5>
                    {/* <span>986 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/IslandHopper`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/14-fpi-ZIwa.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">IslandHopper</a></h5>
                    {/* <span>786 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/General`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/16-D1cIRfhu.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">General</a></h5>
                    {/* <span>786 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Haunted`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/15-CGaqJfSo.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Haunted</a></h5>
                    {/* <span>568 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/14-fpi-ZIwa.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Temple</a></h5>
                    <span>256 Places</span>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/13-CeWMv36_.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Festival</a></h5>
                    <span>654 Places</span>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Visa Types And Eligibility Assessment</h4>
            </div>
          </div>
          <div>
            <Carousel
              responsive={Vehicles}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              <div className="vehicles">
                <div className="card shadow text-center align-items-center h-100 p-3 border-0">
                  <div className="icon-visa rounded-circle" style={{ backgroundColor: '#fe6c3f' }}>
                    <img src="../images/sv.svg" className="w-90px" alt="vehicleImg" />
                  </div>
                  <div className="card-body px-0 pb-0">
                    <h5 className="card-title">
                      <Link to='/'>Tourist Visa</Link>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="vehicles">
                <div className="card shadow text-center align-items-center h-100 p-3 border-0">
                  <div className="icon-visa rounded-circle" style={{ backgroundColor: '#897cb5' }}>
                    <img src="../images/sv1.svg" className="w-90px" alt="vehicleImg" />
                  </div>
                  <div className="card-body px-0 pb-0">
                    <h5 className="card-title">
                      <Link to='/'>Commercial Visa</Link>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="vehicles">
                <div className="card shadow text-center align-items-center h-100 p-3 border-0">
                  <div className="icon-visa rounded-circle" style={{ backgroundColor: '#0c9' }}>
                    <img src="../images/sv2.svg" className="w-90px" alt="vehicleImg" />
                  </div>
                  <div className="card-body px-0 pb-0">
                    <h5 className="card-title">
                      <Link to='/'>Student Visa</Link>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="vehicles">
                <div className="card shadow text-center align-items-center h-100 p-3 border-0">
                  <div className="icon-visa rounded-circle" style={{ backgroundColor: '#0091ff' }}>
                    <img src="../images/sv3.svg" className="w-90px" alt="vehicleImg" />
                  </div>
                  <div className="card-body px-0 pb-0">
                    <h5 className="card-title">
                      <Link to='/'>Residence Visa</Link>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="vehicles">
                <div className="card shadow text-center align-items-center h-100 p-3 border-0">
                  <div className="icon-visa rounded-circle" style={{ backgroundColor: '#ffbd0f' }}>
                    <img src="../images/sv4.svg" className="w-90px" alt="vehicleImg" />
                  </div>
                  <div className="card-body px-0 pb-0">
                    <h5 className="card-title">
                      <Link to='/'>Working Visa</Link>
                    </h5>
                  </div>
                </div>
              </div>
            </Carousel>
          </div>
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Dependable and Trustworthy Visa & Immigration Guidance</h4>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-sm-6 col-lg-4">
              <div className="card shadow p-4 h-100 border-0">
                <div className="icon-lg bg-primary bg-opacity-10 text-primary rounded-circle mb-4">
                  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="fs-5">
                    <path d="M5.52.359A.5.5 0 0 1 6 0h4a.5.5 0 0 1 .474.658L8.694 6H12.5a.5.5 0 0 1 .395.807l-7 9a.5.5 0 0 1-.873-.454L6.823 9.5H3.5a.5.5 0 0 1-.48-.641z"></path>
                  </svg>
                </div>
                <h5>Choose your visa type</h5>
                <p className="mb-0"> Determine the Visa type for your travel purpose.</p>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4">
              <div className="card shadow p-4 h-100 border-0">
                <div className="icon-lg bg-success bg-opacity-10 text-success rounded-circle mb-4">
                  <svg className="svg-inline--fa fa-leaf fa-solid fa-leaf fs-5" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="leaf" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path className="" fill="currentColor" d="M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.3 5.4c-25.9 5.9-49.9 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"></path>
                  </svg>
                </div>
                <h5>Contact our branches</h5>
                <p className="mb-0"> Start your transaction by applying to our branches.</p>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4">
              <div className="card shadow p-4 h-100 border-0">
                <div className="icon-lg bg-warning bg-opacity-15 text-warning rounded-circle mb-4">
                  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="fs-5">
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m6.43-5.228a7.03 7.03 0 0 1-3.658 3.658l-1.115-2.788a4 4 0 0 0 1.985-1.985zM5.228 14.43a7.03 7.03 0 0 1-3.658-3.658l2.788-1.115a4 4 0 0 0 1.985 1.985zm9.202-9.202-2.788 1.115a4 4 0 0 0-1.985-1.985l1.115-2.788a7.03 7.03 0 0 1 3.658 3.658m-8.087-.87a4 4 0 0 0-1.985 1.985L1.57 5.228A7.03 7.03 0 0 1 5.228 1.57zM8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6"></path>
                  </svg>
                </div>
                <h5>Submit All Your Documents</h5>
                <p className="mb-0"> Collect all the required documents the process.</p>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4">
              <div className="card shadow p-4 h-100 border-0">
                <div className="icon-lg bg-danger bg-opacity-10 text-danger rounded-circle mb-4">
                  <svg className="svg-inline--fa fa-car fs-5" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="car" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path className="" fill="currentColor" d="M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"></path>
                  </svg>
                </div>
                <h5>Passport delivery</h5>
                <p className="mb-0"> Receive your visa, which is finalized after application,</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-lg-8 pb-5">
        <div className="container position-relative">
          <div className="position-absolute bottom-0 end-0 z-index-99 me-8 d-none d-lg-block">
            <img src="../images/01-CZ9gE7-a.png" className="h-400px mb-3" alt="" />
          </div>
          <div className="row">
            <div className="col-12">
              <div className="bg-light rounded-2 position-relative overflow-hidden p-4 p-sm-5">
                <figure className="position-absolute bottom-0 start-0 mb-n1">
                  <svg className="fill-primary" width="77px" height="77px">
                    <path d="M76.997,41.258 L45.173,41.258 L67.676,63.760 L63.763,67.673 L41.261,45.171 L41.261,76.994 L35.728,76.994 L35.728,45.171 L13.226,67.673 L9.313,63.760 L31.816,41.258 L-0.007,41.258 L-0.007,35.725 L31.816,35.725 L9.313,13.223 L13.226,9.311 L35.728,31.813 L35.728,-0.010 L41.261,-0.010 L41.261,31.813 L63.763,9.311 L67.676,13.223 L45.174,35.725 L76.997,35.725 L76.997,41.258 Z"></path>
                  </svg>
                </figure>
                <figure className="position-absolute top-0 start-50 translate-middle ms-9">
                  <svg className="fill-warning" width="191.7px" height="211px" viewBox="0 0 191.7 211">
                    <path d="M183.4,105.8c0-0.8-0.1-1.4-0.2-2c-0.2-1-0.5-2-0.8-3c-0.3-1.5-1-2.9-1.5-4.3c-0.2-0.5-0.3-1-0.6-1.4 c-0.3-0.4-0.5-0.9-0.7-1.4c0-0.1-0.1-0.2-0.3-0.1c0.1,0.2,0,0.4,0.2,0.7c0.5,1.1,0.9,2.2,1.3,3.3c0.5,1.2,0.8,2.4,1.2,3.6 c0.2,0.7,0.4,1.3,0.6,2C182.7,104,182.8,104.9,183.4,105.8 M120.9,62.4c0.3,0,0.5,0.3,0.8,0.2c0.4-0.1,0.6-0.4,1-0.6 c0.5-0.3,0.6-0.7,0.6-1.2c0-0.4,0.3-0.3,0.5-0.4c0-0.8,0-1.6-0.8-2.2C122.4,59.6,121.1,60.7,120.9,62.4 M148.7,166.5 c-1.9,0.9-5.9,4.1-6.5,5.8c0.5-0.3,1.1-0.4,1.2-1c0.1-0.2,0.4-0.4,0.6-0.6c0.2-0.3,0.6,0,0.9-0.3c0.2-0.3,0.7-0.5,0.9-0.8 c0.2-0.5,0.7-0.5,1-0.8c0.2-0.3,0.5-0.7,0.9-0.8c0.4-0.2,0.4-0.7,0.9-0.7c0.5,0,0.4-0.7,0.8-0.6c0.4-0.5,1.1-0.7,1.5-1.2 c0.1-0.2,0.2-0.3,0-0.5c-0.5,0.1-0.9,0.5-1.3,0.8c-0.3,0-0.4-0.4-0.7-0.2c0,0-0.1,0-0.1,0.1C148.7,165.8,148.7,166.1,148.7,166.5  M159,171.3c-1.2,0.4-1.8,1.5-2.8,2.1c-1,0.6-1.9,1.4-2.9,2.2c-1,0.8-1.9,1.6-2.8,2.4c0.2,0.1,0.4,0.1,0.6,0 c0.7-0.7,1.8-0.6,2.3-1.5c0.7,0,1-0.6,1.4-0.9c0.3-0.3,0.7-0.4,1-0.4c0.3-0.5,0.6-0.8,1-1c0.4-0.2,0.6-0.7,1.1-0.8 c-0.3-0.7-0.3-0.7,0.7-1c0-0.2-0.3-0.2-0.2-0.5C158.6,171.7,158.8,171.5,159,171.3 M127.8,135.8c1.4-1.9,2.6-3.9,3.7-5.9 c1.3-2.5,2.5-5,3.8-7.4c0.1-0.3,0.2-0.5,0-0.8c-2.7,4.5-5,9.1-7.4,13.6C127.7,135.4,127.8,135.6,127.8,135.8 M38.9,72.2 c-0.4,0.4-0.8,0.8-1.2,1.2c-0.3,0.4-0.8,0.7-1.1,1.1c-0.5,0.5-0.8,1.2-1.3,1.7c-1,1-1.9,2.1-2.8,3.2c-1.4,1.7-2.4,3.7-3.6,5.6 c-0.3,0.4-0.5,0.9-0.7,1.4c3.7-4.5,6.8-9.5,10.8-13.8C39.1,72.5,39,72.3,38.9,72.2 M94.1,198.1c0.1,0.4,0.1,0.6,0.2,0.8 c-0.6,0-0.2,0.9-0.9,1c-0.7,0-1.4-0.1-2.2,0.2c-0.4,0.1-0.3,0.3-0.2,0.5c0.6,0,1.2,0.1,1.6-0.3c0.3,0.1,0.1,0.4,0.4,0.5 c0.8,0,1.6,0.2,2.3,0c0.8-0.3,1.5-0.1,2.2-0.2c0.8,0,1.5,0,2.3,0c0.2,0,0.4,0,0.6,0c0.1,0,0.1-0.1,0.2-0.1c0-0.2,0.1-0.4,0-0.6 c-0.7,0.3-0.7,0.2-1.2-0.2c-0.3-0.2,0-0.4,0-0.5c-0.1-0.4-0.6-0.2-0.9-0.4c-0.2-0.1,0.2-0.5-0.2-0.6c-0.2,0.4,0.2,0.9-0.4,1.2 c-0.6-0.3-0.6-0.3-1.1,0.4c0,0.3,0.5,0,0.5,0.4c-0.3,0-0.6,0.2-0.7-0.3c0-0.2-0.5-0.3-0.6-0.4c-0.3,0-0.3,0.3-0.5,0.2 c-0.3-0.2-0.3-0.6-0.5-0.8c0.1-0.2,0.4-0.3,0.4-0.5c-0.4-0.2-0.5,0.3-0.8,0.2C94.4,198.4,94.3,198.3,94.1,198.1 M101.9,167.3 c0-0.9,0.6-1.5,0.8-2.3c0.2-1,0.6-2,0.8-2.9c0.2-0.8,0.5-1.7,0.6-2.5c0.2-0.9,0.5-1.7,0.7-2.6c0.2-0.9,0.4-1.8,0.7-2.7 c0.2-0.5,0.4-1,0.5-1.5c0.1-0.6,0.2-1.2,0.5-1.7c0.3-0.5,0-1.3,0.7-1.7c0.2-0.1,0.1-0.4,0-0.6c0-0.1-0.2-0.2-0.1-0.3 c0.5-0.5,0.3-1.2,0.6-1.8c-0.2,0-0.4,0-0.5,0.3c-0.4,1.3-0.9,2.6-1.4,3.9c-0.1,0.5-0.4,0.9-0.3,1.4c-0.6,1-0.7,2.1-0.9,3.1 c-0.2,1.1-0.6,2.1-0.8,3.2c-0.6,2.3-1.1,4.7-1.9,7C102.1,166.1,101.4,166.6,101.9,167.3 M23.2,154c-0.1-0.3-0.2-0.6-0.4-0.8 c-0.1-0.1-0.3-0.1-0.4-0.3c-0.3-1.1-0.6-2.1-1-3.1c-0.2-0.5-0.3-1.1-0.7-1.5c-1.1-1.2-2.1-2.4-3.2-3.7c-0.1-0.1-0.3-0.2-0.3-0.4 c0-0.3-0.3-0.4-0.4-0.5c-0.1-0.1-0.2-0.4-0.6-0.4c0.7,1.7,1.6,3.2,2.5,4.7c0.9,1.4,1.7,2.9,2.7,4.2c0.4,0.6,0.8,1.3,1.1,2 c0,0.1,0.2,0.1,0.2,0.2C23,154.2,23.1,154.1,23.2,154 M90.5,85.8c0.5-0.1,0.4-0.6,0.7-0.8c0.3-0.2,0.5-0.6,0.8-0.9 c0.9-1.2,1.8-2.4,2.8-3.6c0.7-0.9,1.4-1.7,2-2.6c0.6-0.9,1.4-1.7,1.9-2.6c0.5-0.9,1.4-1.5,1.7-2.5c-0.6-0.4-1-0.4-1.5,0.1 c-0.7,0.8-1.3,1.7-1.9,2.5c-0.4,0.6-0.8,1.2-1.2,1.8c-0.9,1.1-1.6,2.3-2.4,3.5c-0.9,1.4-1.8,2.9-2.8,4.3 C90.5,85.3,90.4,85.5,90.5,85.8 M140.6,176.1c0.5-0.5,1.1-0.7,1.7-1c0.7-0.4,1.3-0.8,1.9-1.2c0.3-0.1,0.2-0.6,0.6-0.5 c0.6-1.2,1.7-1.9,2.8-2.7c0.1,0.1,0.3,0.2,0.4,0.3c0.1-0.1,0.2-0.2,0.3-0.3c-0.1-0.1-0.2-0.2-0.2-0.3c0.2-0.3,0.6,0.1,0.7-0.3 c-0.1-0.1-0.3-0.1-0.4-0.2c0-0.7,0-0.7,0.7-0.9c0.1,0,0.2-0.1,0.2-0.2c0-0.2-0.2-0.3-0.2-0.4c0.1-0.3,0.7-0.4,0.4-0.8 c-0.8,0.3-1.2,0.9-1.8,1.4c-0.7,0.5-1.4,1-2,1.6c-0.6,0.6-1.2,1.1-1.9,1.6c-0.7,0.6-1.5,1.1-2.2,1.7c-0.2,0.2-0.4,0.6-0.7,0.7 c-0.4,0.1-0.6,0.4-0.8,0.6c-0.3,0.3-0.5,0.5-0.8,0.8C139.7,176.4,140.2,175.5,140.6,176.1 M130.5,206.4c0.2,0.2,0.5,0.1,0.7,0 c1-0.4,2-0.7,3-1.1c1.8-0.6,3.5-1.4,5.2-2.2c2.9-1.3,5.8-2.8,8.5-4.4c1.2-0.7,2.3-1.4,3.5-2.2c1.2-0.8,2.4-1.7,3.6-2.6 c1.2-0.8,2.2-1.7,3.3-2.6c0.9-0.7,1.7-1.6,2.7-2.2c0.2-0.1,0.4-0.3,0.5-0.5c0.2-0.2,0.4-0.3,0.5-0.5c-0.3-0.2-0.4,0-0.5,0.1 c-0.5,0.6-1.1,1-1.7,1.4c-1.4,1-2.7,2.2-4.1,3.2c-0.7,0.6-1.5,1.2-2.2,1.7c-1.8,1.1-3.4,2.3-5.2,3.3c-2.4,1.4-4.8,2.7-7.2,4.1 c-0.6,0.3-1.2,0.4-1.8,0.7c-1.2,0.7-2.5,1.3-3.8,1.8c-1,0.3-1.9,0.9-2.9,1.2C131.8,205.8,131.1,206,130.5,206.4 M10.6,79.8 c0.1-0.1,0.3-0.3,0.4-0.4c-0.3-0.2-0.3-0.5-0.4-0.8c0.2-0.5,0.8,0.1,0.9-0.5c-0.1-0.2-0.4,0-0.5-0.3c-0.1-0.4,0.2-0.7,0.4-1 c0.2-0.1,0.4,0.1,0.6-0.1c-0.2-0.3-0.4-0.5-0.1-0.8c0.4-0.6,0.6-1.5,1.2-1.9c0.2-0.2,0.1-0.5,0.4-0.7c-0.2-0.6,0.3-1,0.5-1.4 c0.8-1.4,1.6-2.8,2.4-4.1c1.2-1.8,2.3-3.5,3.6-5.2c0.9-1.1,1.7-2.4,2.8-3.4c0.2-0.2,0.2-0.3,0-0.4c-4.4,3.8-7.5,8.7-10,13.9 c-0.2-0.2-0.3-0.3-0.5-0.2c-0.2,0.4-0.3,0.8-0.6,1.2c-0.3,0.5-0.3,0.8,0,1.2c-0.2,0.5-0.5,0.9-0.6,1.2c-0.2,0-0.5,0-0.5,0.1 c-0.3,0.6-0.8,1.1-0.6,1.8c-0.5,0-0.5,0.5-0.7,0.7c0.2,0.4-0.6,0.7-0.1,1.2c0.3,0.4,0.1,0.7-0.3,0.9c-0.1-0.1-0.1-0.1-0.2-0.2 c0,0.4-0.5,0.5-0.3,0.9c0.2,0.2,0.3-0.3,0.5,0C8.6,82,8.4,82.7,8,83.3c-0.2,0.4-0.2,0.7-0.1,1.1c0.3-0.5,0.3-1,0.9-1.2 c-0.2-0.2-0.4-0.3-0.1-0.6c0.2-0.3,0.5-0.2,0.8-0.3c0.1,0,0.1-0.1,0.1-0.2c-0.1-0.1-0.3-0.1-0.5-0.2c0.5-0.9,0.8-1.8,1.4-2.6 C10.5,79.6,10.5,79.7,10.6,79.8 M21.4,74.7c0.9-0.5,1.3-1.4,2-2c0.5-0.5,1-1.2,1.5-1.8c0.5-0.7,1.1-1.2,1.6-1.9 c0.7-1,1.5-1.9,2.3-2.8c0.2-0.2,0.5-0.4,0.7-0.7c0.3-0.7,1-1.1,1.5-1.7c0.5-0.6,0.8-1.3,1.4-1.7c0.2-0.1,0.4-0.1,0.5-0.4 c0.7-1,1.8-1.7,2.4-2.8c0.5-0.1,0.5-0.6,0.8-0.9c0.3-0.3,0.6-0.6,0.9-0.9c-0.6-0.3-0.7,0.3-1,0.4c-1.2,0.7-2.3,1.5-3.4,2.5 c-2,1.8-3.8,3.9-5.5,6c-0.4,0.5-0.9,1-1.3,1.5c-1.3,1.8-2.6,3.7-3.9,5.6C21.8,73.6,21.6,74,21.4,74.7 M65.2,30.8 c-0.5-0.4-0.8-0.2-1.1,0.1v0.8c-0.7,0-0.6,1-1.2,1.3c-0.6,0.2-1,0.8-1.4,1.3c0.1,0.3,0.5,0.1,0.6,0.4c0.4-0.4,0.7-0.9,1.3-0.8v-0.6 c0.5-0.1,0.8-0.5,1.1-0.8c0.3-0.3,0.9-0.3,0.9-0.9c0.6,0.1,0.6-0.6,1-0.8c0.4-0.2,0.7-0.6,1-0.9c0.3-0.3,0.6-0.8,0.9-1.1 c0.3-0.3,0.5-0.7,0.9-1c0.4-0.3,0.9-0.4,1-0.9c0.2-0.5,0.6-0.7,1-0.9c-0.2-0.8,0.4-0.8,1-0.9c-0.1-0.1-0.2-0.2-0.2-0.2 c0-0.3,0.3-0.1,0.4-0.3c0.2-0.5,0.5-1.1,1-1.4c0.6-0.3,0.8-0.9,1.3-1.3c1.7-1.7,3.4-3.3,5.2-4.9c0.1-0.1,0.2-0.3,0.4-0.3 c0.8-0.2,1.2-0.8,1.8-1.3c0.6-0.5,1.2-1.1,1.8-1.5c1-0.6,1.9-1.2,2.7-2c0.2,0.1,0.2,0.2,0.3,0.2c0.5-0.4,0.8-1,1.3-1.1 c0.6-0.1,0.8-0.6,1.4-1c-1.2,0.1-1.2,0.1-1.8,0.7c-0.4-0.3-0.8,0.3-1.2,0c-0.1,0.4,0,1-0.8,1c-0.1,0-0.3,0.1-0.3,0.2 c-0.3,0.8-1.1,1-1.7,1.4c-0.5,0.4-1,0.8-1.6,0.6c-0.3,0.6-0.6,1-1.1,1.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.3-0.3,0.6-0.4,0.9 c-0.4,0-0.8,0.2-1.1,0.4v0.5c-0.4,0.1-0.6,0.3-0.8,0.6c-0.2,0.2-0.6,0.2-0.7,0.7c-0.1,0.3-0.5,0.5-0.7,0.8c-0.3,0.1-0.6-0.1-0.9,0.1 c0.2,0.1,0.4,0.1,0.7,0.3c-0.7,0-0.7,0.5-0.9,0.8c-0.5,0.4-0.9,0.9-1.4,1.4c0.2,0.5-0.5,0.2-0.5,0.6c0,0.5-0.6,0-0.7,0.4 c0.1,0.1,0.1,0.2,0.1,0.1c-0.6,0.6-1.1,1.1-1.7,1.7c-0.1,0.2-0.2-0.3-0.4-0.1c-0.3,0.3,0.6,0.5,0.1,0.8c-0.2,0-0.2-0.3-0.4-0.1 c-0.1,0.2,0.1,0.5-0.2,0.7c-0.1-0.2-0.3-0.3-0.4-0.3C70,25,70,25.1,70,25.2c0,0.5-0.1,1-0.7,1.2c0,0.5-0.5,0.5-0.8,0.8 c-0.2,0.3-0.6,0.5-0.8,0.9C67.1,29.1,66,29.8,65.2,30.8 M1.2,100.8c-0.3-0.2-0.3-0.6-0.2-0.9c0.6-1.7,0.8-3.5,1.3-5.2 C2.6,93.9,2.8,93,3,92c0.1-0.8,0.5-1.4,0.6-2.2C3.7,89,4,88.2,4.2,87.4c0.2-0.7,0.5-1.3,0.7-2c0.3-1,0.6-2,1-3 c0.2-0.6,0.4-1.3,0.8-1.8c0.1-0.1,0.1-0.3,0.1-0.4c0.2-0.6,0.4-1.2,0.7-1.8c0.6-1.2,1.1-2.5,1.7-3.7c0.5-0.9,0.9-1.8,1.3-2.6 c0.4-0.8,0.8-1.7,1.3-2.5c1-1.9,2.2-3.8,3.5-5.6c1-1.4,2.1-2.7,3.2-4c0.9-1.1,1.8-2.1,2.9-3c0.8-0.7,1.6-1.6,2.5-2.2 c0.8-0.6,1.7-1.3,2.5-1.9c1.9-1.4,3.9-2.8,5.9-4.1c1.2-0.8,2.4-1.5,3.6-2.3c1.4-0.9,2.8-1.6,4.2-2.5c0.8-0.5,1.7-1,2.6-1.4 c0.8-0.5,1.7-0.8,2.5-1.3c0.8-0.5,1.7-0.9,2.5-1.3c0.8-0.4,1.5-1,2.5-1.1c0.4-0.7,1.2-0.7,1.8-1c0.6-0.3,1.2-0.6,1.8-1 c0.6-0.4,1.2-0.7,1.8-1.1c1.2-0.7,2.3-1.5,3.5-2.2c0.7-0.4,1.2-1.1,1.9-1.5c1.3-0.9,2.4-2,3.5-3.1c0.4-0.5,0.9-0.9,1.4-1.2 c0.4-0.2,0.4-0.7,0.8-1c0.6-0.5,1-1,1.6-1.5c0.2-0.2,0.3-0.3,0.3-0.6c0.3,0,0.4,0,0.6-0.1c0.2-0.2-0.1-0.2-0.1-0.3 c0.2-0.2,0.3-0.5,0.7-0.6c0.3-0.1,0.3-0.5,0.5-0.7c0.6-0.4,0.7-1.3,1.5-1.5c0.2-0.7,0.8-1.1,1.2-1.7c0.2-0.3,0.5-0.5,0.8-0.6 c0.3-0.1,0.1-0.7,0.6-0.6c0.5-1.1,1.6-1.6,2.4-2.3c1.4-1.2,2.6-2.4,4.2-3.4c0.8-0.5,1.5-1.2,2.2-1.7c1.8-1.1,3.5-2.3,5.4-3.2 c0.8-0.4,1.5-0.9,2.3-1.3c1.7-0.8,3.3-1.5,5.1-2.2c0.3-0.1,0.6-0.3,1-0.2c0.4,0.1,0.6-0.4,0.9-0.5c0.4-0.1,0.9-0.1,1.3-0.3 c0.2-0.1,0.7-0.2,1-0.3c0.9-0.5,2-0.4,2.9-0.9c0.3-0.2,0.8-0.1,1.1-0.1c1.2-0.1,2.4-0.7,3.6-0.6c0.7,0,1.3-0.1,1.9-0.4 c0.2-0.1,0.4-0.2,0.6-0.1c0.6,0.2,1.1,0,1.6,0c0.6,0,1.1-0.3,1.7-0.2c0.6,0,1.3,0.2,1.8,0c1-0.3,2-0.2,3-0.2c0.5,0,1-0.2,1.5,0.2 c0.2,0.2,0.5-0.5,0.8-0.1c0.2,0.2,0.5,0.2,0.7,0c0.3-0.1,0.6,0.3,0.8,0.1c0.2-0.2,0.6-0.4,0.7-0.2c0.2,0.4,0.6-0.1,0.7,0.2 c0,0,0.1,0,0.1,0c1.1-0.1,2.1,0.3,3.2,0.3c0.6,0,1.3,0.1,1.9,0.3c0.6,0.2,1.2,0.3,1.8,0.4c1,0.2,2,0.6,3,0.8c0.3,0,0.3,0.7,0.8,0.3 c0.2,0.4,0.6,0.1,0.9,0.2c0.2,0.1,0.4,0.3,0.6,0.5c0.6-0.1,1.1,0.2,1.7,0.4c1.1,0.4,2.2,0.9,3.3,1.5c1.4,0.8,2.9,1.5,4.1,2.8 c0.2,0.3,0.5,0,0.8,0.2c1.3,1.2,2.8,2.2,3.9,3.6c0.5,0.6,1.2,1,1.7,1.6c1,1.2,2.1,2.3,3,3.6c0.5,0.8,1.1,1.6,1.7,2.4 c1.1,1.7,2.1,3.4,2.8,5.3c0.5,1.4,1,2.8,1.4,4.3c0.1,0.5,0.1,1,0.2,1.5c0.2,0.5,0.2,0.9,0.2,1.4c0,0.4,0.3,0.6,0.3,1 c-0.1,0.3-0.1,0.7,0.2,1c0.1,0.2,0,0.5,0,0.8c0,0.4,0.1,0.8,0,1.2c-0.1,0.3,0.4,0.6,0,0.9c0.4,0.3,0.2,0.7,0.2,1.1 c0,0.4,0,0.7,0,1.1v1.2c0,0.4-0.1,0.8,0,1.1c0.2,0.6,0.1,1.3,0.2,1.9c0.1,0.7,0.1,1.5,0,2.2c0,0.6,0.4,1.2,0.3,1.9 c-0.1,0.6-0.2,1.3,0,1.9c0.2,0.7,0,1.4,0.3,2c0.3,0.7,0,1.4,0.2,2c0.4,1.4,0.4,2.8,0.8,4.2c0.5,1.7,0.7,3.5,1.3,5.2 c0.4,1.1,0.8,2.2,1.1,3.3c0.4,1.1,0.9,2.1,1.5,3.2c0.7,1.3,1.5,2.5,2.4,3.6c0.9,1.2,1.9,2.2,2.8,3.3c0.4,0.5,0.9,1,1.3,1.5 c0.4,0.6,1.1,1,1.5,1.6c1.1,1.5,2.5,2.6,3.5,4.2c1.7,1.6,2.7,3.6,4.1,5.4c0.7,0.9,1.2,1.9,1.7,2.9c1,1.6,1.8,3.3,2.6,5 c0.8,1.6,1.4,3.2,1.9,4.8c0.4,1.2,0.7,2.4,1.1,3.6c0.2,0.5-0.1,1,0.3,1.4c0,1.1,0.6,2.2,0.5,3.3c0.4,0.7,0.3,1.4,0.2,2.1 c0,0.5,0.4,0.9,0.3,1.5c-0.1,0.5-0.2,1.1,0,1.6c0.3,0.8,0.2,1.7,0.2,2.5c0,1.9,0,3.8,0,5.7c0,0.6,0.2,1.3-0.1,1.9 c-0.3,0.5,0.1,1.2-0.3,1.7c-0.1,0.2,0.2,0.3,0.2,0.6c-0.1,0.5,0.2,1.1-0.2,1.6c-0.3,0.4,0.1,1-0.3,1.5c-0.2,0.3,0.6,0.7,0,1 c0.1,0.7-0.1,1.3-0.2,2c-0.1,0.5,0.2,1.1-0.2,1.6c-0.3,0.5,0.2,1.1-0.3,1.6c0.2,0.8-0.3,1.5-0.3,2.3c0,0.6-0.2,1.2-0.3,1.8 c-0.2,0.9-0.4,1.9-0.6,2.8c-0.1,0.3-0.2,0.7-0.3,1c-0.1,0.2-0.3,0.3-0.3,0.5c0,1.5-0.5,2.9-1,4.3c-0.3,0.8-0.5,1.7-0.9,2.6 c-0.1,0.2-0.1,0.6-0.3,0.8c-0.5,0.6-0.7,1.4-0.9,2.2c-0.1,0.4-0.3,0.8-0.5,1.1c0,0.1-0.2,0.1-0.2,0.2c0,1.1-0.7,1.9-1.1,2.8 c-0.4,0.9-1,1.7-1.3,2.6c-0.8,1.8-1.9,3.4-2.7,5.2c-0.3,0.6-0.7,1.1-0.9,1.5c-0.1,0.4,0.2,0.4,0.2,0.8c-0.1,0.3-0.3,0.4-0.7,0.5 c0.2,0.9-0.5,1.5-0.9,2.1c-0.9,1.6-1.9,3.1-3,4.6c-0.7,1-1.4,2-2.2,2.9c-2.6,2.9-5.3,5.6-8.1,8.3c-1.1,1-2.1,2.1-3.3,3 c-1,0.8-1.9,1.7-2.9,2.4c-2.3,1.8-4.7,3.5-7.1,5.1c-1.9,1.2-3.8,2.3-5.8,3.4c-1.2,0.7-2.5,1.4-3.8,1.9c-2.1,1-4.2,1.9-6.3,2.7 c-2,0.8-4.1,1.2-6.1,2.1c-1.3,0-2.5,0.8-3.8,0.8c-0.6,0.4-1.3,0.3-1.9,0.4c-0.6,0.1-1.3,0.4-2,0.3c-0.3,0-0.6,0.3-1,0.2 c-0.3-0.1-0.7-0.1-1,0.2c-0.3-0.4-0.5,0.2-0.8,0.1c-0.3-0.1-0.8-0.1-1.1,0c-0.8,0.3-1.6,0-2.3,0.3c-0.8,0.3-1.5,0-2.2,0.2 c-0.9,0.3-1.7-0.2-2.5,0c-0.1,0-0.2-0.1-0.3-0.2c-0.2,0.1-0.1,0.3-0.2,0.4c-0.3-0.2-0.5-0.4-0.8-0.4c-0.3-0.1-0.7,0-1.2,0 c-0.2,0.2-0.4,0.5-0.6,0.8c-0.5-0.1-0.9,0.1-1.3-0.2c-0.2-0.1-0.6,0.1-0.9,0.1c-0.4,0.1-0.8-0.4-1.1-0.2c-0.4,0.3-0.8,0.2-1.2,0.2 c-3.5,0-7.1,0-10.6,0c-0.4,0-0.8,0.2-1.1-0.2c-0.4,0.6-0.7-0.1-1.1,0c-0.4,0.1-0.7-0.1-1.1-0.2c-0.6-0.2-1.4,0-2.1-0.1 c-0.5,0-0.9,0.1-1.4-0.2c-0.4-0.2-0.9-0.1-1.4-0.2c-0.6-0.1-1.2-0.3-1.8-0.3c-0.4,0-0.8,0-1.3-0.2c-0.3-0.2-0.8,0.1-1.1-0.3 c-0.8,0-1.6-0.3-2.4-0.5c-1.9-0.4-3.7-1-5.6-1.6c-1.5-0.5-3.1-1-4.6-1.6c-0.5-0.2-1-0.4-1.5-0.6c-1.7-0.8-3.5-1.5-5.1-2.4 c-1.4-0.8-2.9-1.6-4.3-2.5c-0.7-0.5-1.6-0.8-2.4-1.3c-1.8-1.1-3.7-2.2-5.4-3.4c-1.5-1.1-3.1-2.1-4.4-3.4c-0.3-0.4-0.8-0.6-1.2-0.9 c-0.4-0.4-0.8-0.9-1.2-1.2c-0.6-0.4-1.1-1-1.6-1.4c-0.4-0.3-0.4-1-1.1-1.2c-0.5-0.1-0.5-0.9-1.1-1.1c-0.2-0.8-1-0.9-1.4-1.6 c-0.4-0.7-1-1.1-1.6-1.7c-0.5-0.5-1.2-1-1.6-1.7c-0.9-1.1-2-2-2.8-3.1c-0.8-1-1.9-1.9-2.5-3.1c-0.1-0.3-0.4-0.2-0.6-0.3 c-0.2-0.2-0.1-0.4-0.3-0.6c-0.7-0.7-1.3-1.4-2-2.2c-0.9-1.1-1.7-2.2-2.6-3.3c-1.4-1.7-2.6-3.5-3.8-5.3c-0.8-1.2-1.5-2.4-2.3-3.6 c-0.9-1.4-1.7-2.8-2.6-4.2c-0.6-1.1-1.2-2.2-1.8-3.3c-0.5-0.9-1-1.7-1.5-2.5c-0.7-1.2-1.4-2.3-2.1-3.5c-1-1.6-1.9-3.3-2.8-5.1 c-0.4-0.9-0.8-1.8-1.2-2.7c-0.2-0.6-0.4-1.2-0.7-1.8c-0.6-1.1-0.8-2.4-1.2-3.5c-0.1-0.4-0.2-0.8-0.3-1.2c-0.1-0.4-0.2-0.7-0.2-1.1 c-0.2-1.1-0.2-2.3-0.7-3.4c0-0.1,0-0.2,0-0.2c0.1-1.3-0.4-2.5-0.3-3.8c0.1-1.1-0.4-2.3-0.2-3.4c-0.4-0.7-0.1-1.4-0.3-2.1 c-0.4-1.8-0.2-3.7-0.2-5.5c0-1.8,0-3.7,0-5.5c0-1.3,0.3-2.5,0.5-3.8c0-0.3,0.2-0.6,0.2-0.9C0.7,101.7,0.9,101.2,1.2,100.8"></path>
                  </svg>
                </figure>
                <figure className="position-absolute bottom-0 end-0 me-6 mb-n6 d-none d-sm-block">
                  <svg className="fill-info" width="189.7px" height="182.4px" viewBox="0 0 189.7 182.4">
                    <path d="M27.2,37.9c-1.9,1.4-3.2,2.6-4,4.4c-0.2,0.5-0.5,1,0.1,1.4c0.3,0.2,1.1,0,1.1,0C24.5,41.4,28.1,41.2,27.2,37.9 M159.4,152.4c0.3,0.2,0.5,0.4,0.8,0.7c3.5-2.6,6.5-5.7,8.8-9.4c-1.7,1.2-3,2.8-4.5,4.2C162.8,149.5,161.1,150.9,159.4,152.4 M58.2,69.6c3.4-5.2,7.7-9.9,9.5-15.9C62.7,57.9,60.6,63.8,58.2,69.6 M133.9,106.2c-3.2,4-7.8,7.2-8.4,13 C129.3,115.5,132.8,111.6,133.9,106.2 M31.5,33.9c7.9-6.7,17-11.9,24.2-19.6C46.5,19.6,37.9,25.4,31.5,33.9 M154.5,109.5 c-7.4,9.6-14.7,18.9-21.9,28.2C146.6,125.7,153.4,116.8,154.5,109.5 M34.4,70.2c0.4-0.2,0.9-0.4,1-0.7C39,59,46.4,51.4,54.4,44 c4-3.6,6.6-8.5,10.1-13.8C53.4,33.8,34.8,59,34.4,70.2 M86.4,182.4c-42.1-0.7-70.8-24.4-82.7-62.1c-6.8-21.6-3.9-42.6,6-62.4 c9.9-20,24.7-36,44.9-46.3C62.9,7.3,72,4.2,80.8,0.8c3.5-1.3,7.1-1,10.8,0.3c4.6,1.6,9.5,2.3,14.4,2.2c10.8-0.4,20.4,3.1,29.3,8.6 c6,3.7,12.5,6.7,17.9,11.4c16.7,14.6,28.3,32.5,34.9,53.6c2.5,8,1.6,16.1,0.8,24.2c-0.4,4.6-2.3,9.2-3,13.7c-0.6,3.5-3.4,6-3.2,8.3 c0.3,3.5-1.1,5.7-2.5,8.1c-13.2,22.9-34,35.9-58.4,44c-8.7,2.9-17.4,5.3-26.4,6.6C91.9,182.3,88.3,182.3,86.4,182.4"></path>
                  </svg>
                </figure>
                <div className="row position-relative p-sm-3">
                  <div className="col-lg-7 downLoadApp">
                    <h3 className="mb-4">Download our app and access exclusive features</h3>
                    <ul className="list-inline position-relative mb-4 items-center flex-wrap gap-2">
                      <li className="list-inline-item me-3 items-center">
                        <div>
                          <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="text-success me-1 mb-1">
                            <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708"></path>
                          </svg>
                        </div>
                        24/7 Customer Support
                      </li>
                      <li className="list-inline-item me-3 items-center">
                        <div>
                          <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="text-success me-1 mb-1">
                            <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708"></path>
                          </svg>
                        </div>
                        Ride Safely
                      </li>
                      <li className="list-inline-item items-center">
                        <div>
                          <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" className="text-success me-1 mb-1">
                            <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708"></path>
                          </svg>
                        </div>
                        Top Rated Driver - Partner
                      </li>
                    </ul>
                    <div className="hstack gap-3">
                      <a aria-current="page" href="#!" className="router-link-active router-link-exact-active">
                        <img src="../images/google-play-7Lsm2fJ4.svg" className="h-50px" alt="" />
                      </a>
                      <a aria-current="page" href="#!" className="router-link-active router-link-exact-active">
                        <img src="../images/app-store-CfYJWrSW.svg" className="h-50px" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Frequently Asked Questions</h4>
            </div>
          </div>
          <div className="row py-3 justify-content-center">
            <div className='col-10'>
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <strong>How Does it Work?</strong>
                </AccordionSummary>
                <AccordionDetails>
                  Yet remarkably appearance gets him his projection. Diverted endeavor bed peculiar men the not desirous. Acuteness abilities ask can offending furnished fulfilled sex. Warrant fifteen exposed ye at mistake. Blush since so in noisy still built up an again. As young ye hopes no he place means. Partiality diminution gay yet entreaties admiration. In mention perhaps attempt pointed suppose. Unknown ye chamber of warrant of Norland arrived.
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  <strong>What are monthly tracked users?</strong>
                </AccordionSummary>
                <AccordionDetails>
                  What deal evil rent by real in. But her ready least set lived spite solid. September how men saw tolerably two behavior arranging. She offices for highest and replied one venture pasture. Applauded no discovery in newspaper allowance am northward. Frequently partiality possession resolution at or appearance unaffected me. Engaged its was the evident pleased husband. Ye goodness felicity do disposal dwelling no. First am plate jokes to began to cause a scale. Subjects he prospect elegance followed no overcame possible it on. Improved own provided blessing may peculiar domestic. Sight house has sex never. No visited raising gravity outward subject my cottage Mr be.
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div>
            <Carousel
              responsive={Customer}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              <div className='customer'>
                <img src="../images/img1.svg" className="w-90px" alt="vehicleImg" />
              </div>
              <div className='customer'>
                <img src="../images/img2.svg" className="w-90px" alt="vehicleImg" />
              </div>
              <div className='customer'>
                <img src="../images/img3.svg" className="w-90px" alt="vehicleImg" />
              </div>
              <div className='customer'>
                <img src="../images/img4.svg" className="w-90px" alt="vehicleImg" />
              </div>
              <div className='customer'>
                <img src="../images/img5.svg" className="w-90px" alt="vehicleImg" />
              </div>
              <div className='customer'>
                <img src="../images/img6.svg" className="w-90px" alt="vehicleImg" />
              </div>
              <div className='customer'>
                <img src="../images/img1.svg" className="w-90px" alt="vehicleImg" />
              </div>
              <div className='customer'>
                <img src="../images/img5.svg" className="w-90px" alt="vehicleImg" />
              </div>
            </Carousel>
          </div>
        </div>
      </section> */}
      <ToastContainer />
      <Footer />
    </>
  )
}

export default Visa

// const top100Films = [
//   { label: 'USA', value: 'USA' },
//   { label: 'CANADA', value: ' CANADA' },
//   { label: 'AUSTRALIA', value: 'AUSTRALIA' },
//   { label: 'UK', value: 'UK' },
//   { label: 'GERMANY', value: 'GERMANY' },
//   { label: "CHINA", value: "CHINA" },

// ];
const visaValidity = [
  { label: '10 Days Visa', value: '10 Days Visa' },
  { label: '30 Days Visa', value: '30 Days Visa' },
  { label: '60 Days Visa', value: '60 Days Visa' },


];
const visaType = [
  { label: 'Tourist Visa', value: 'Tourist Visa' },
  { label: 'Residence Visa', value: 'Residence Visa' },
  { label: 'Study Visa', value: 'Study Visa' },
  { label: 'Working Visa', value: 'Working Visa' },


];